export var CameraViewName;
(function (CameraViewName) {
    CameraViewName["Top"] = "Top";
    CameraViewName["Bottom"] = "Bottom";
    CameraViewName["Left"] = "Left";
    CameraViewName["Right"] = "Right";
    CameraViewName["Front"] = "Front";
    CameraViewName["Back"] = "Back";
    //corners
    CameraViewName["FrontTopRight"] = "FrontTopRight";
    CameraViewName["FrontTopLeft"] = "FrontTopLeft";
    CameraViewName["FrontBottomRight"] = "FrontBottomRight";
    CameraViewName["FrontBottomLeft"] = "FrontBottomLeft";
    CameraViewName["BackTopRight"] = "BackTopRight";
    CameraViewName["BackTopLeft"] = "BackTopLeft";
    CameraViewName["BackBottomRight"] = "BackBottomRight";
    CameraViewName["BackBottomLeft"] = "BackBottomLeft";
    //edges
    CameraViewName["FrontTop"] = "FrontTop";
    CameraViewName["FrontBottom"] = "FrontBottom";
    CameraViewName["FrontRight"] = "FrontRight";
    CameraViewName["FrontLeft"] = "FrontLeft";
    CameraViewName["BackTop"] = "BackTop";
    CameraViewName["BackBottom"] = "BackBottom";
    CameraViewName["BackRight"] = "BackRight";
    CameraViewName["BackLeft"] = "BackLeft";
    CameraViewName["TopRight"] = "TopRight";
    CameraViewName["TopLeft"] = "TopLeft";
    CameraViewName["BottomRight"] = "BottomRight";
    CameraViewName["BottomLeft"] = "BottomLeft";
})(CameraViewName || (CameraViewName = {}));
